import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components/atoms'
import { statusType, modifiersType } from 'types';
import { status } from 'context/EditorContext'

const ButtonPublish = ({
  onClick,
  loading,
  pageStatus,
  modifiers,
}) => {
  const handleClick = () => {
    onClick();
  };

  const computeMessage = useMemo(() => {
    if (pageStatus === status.edited || pageStatus === status.prePublished) return 'Publicar';
    if (pageStatus === status.published) return 'Publicado'
    return 'Gravar'
  }, [pageStatus]);

  const computedModifiers = useMemo(() => {
    const defaultModifiers = ['removeBorders', 'fixedWidthMedium']
    if (pageStatus === status.edited || pageStatus === status.prePublished) return [...defaultModifiers, 'primary'];
    if (pageStatus === status.published) return [...defaultModifiers, 'disabled']
    return [...defaultModifiers, 'dark']
  }, [pageStatus]);

  return (
    <Button
      onClick={handleClick}
      loading={loading}
      modifiers={['removeBorders', ...computedModifiers, ...modifiers]}
    >
      {computeMessage}
    </Button>
  );
};

ButtonPublish.propTypes = {
  onClick: PropTypes.func,
  loading: PropTypes.bool,
  pageStatus: statusType,
  modifiers: modifiersType,
};

ButtonPublish.defaultProps = {
  onClick: () => null,
  loading: false,
  pageStatus: status.none,
  modifiers: []
};

export default ButtonPublish;
